import styled from "styled-components"; 
import css from "styled-components";

export const FormWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    padding: 0 20px;
    background-color: #fff;
`

export const FormContainer = styled.form`
    padding: 30px;
    width: 800px;
    background-color: #fff;
    box-sizing: border-box;
    
`

export const Input = styled.input`
    display: block;
    width: 100%; 
    background-color: #eee;
    height: 30px;
    border: 1px solid #ddd;
    margin: 0 0 20px 0;
    padding: 20px;
    box-sizing: border-box;
`

export const NumInput = styled.input`
    display: block;
    width: 50%; 
    background-color: #eee;
    height: 30px;
    border: 1px solid #ddd;
    padding: 20px;
    box-sizing: border-box;
`

export const Btn = styled.button`
    display: block;
    background-color: #c2e8ba;
    color: #000;
    font-size: 0.9rem;
    border: 0;
    height: 40px;
    padding: 0 20px;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
        transform: scale(1.05);
        transition: all 0.2s ease-in-out;
        background: #87D278;
        color: #000;
    }
`

export const TextArea = styled.textarea`
    width: 100%;
    min-height: 100px;
    resize: none;
    background-color: #eee;
    height: 40px;
    border: 1px solid #ddd;
    margin: 10px 0 20px 0;
    padding: 20px;
    box-sizing: border-box;
`

export const FieldSet = styled.fieldset`
    border: 1px solid #ddd;
    padding: 10px;
    margin-bottom: 20px;
    
    legend {
        padding: 0 10px;
    }

    label {
        padding-right: 20px;
    }

    input {
        margin-right: 10px;
    }
`

export const Error = styled.div`
    color: red;
    font-weight: 700;
    margin: 0 0 40px 0; 
`

export const Heading = styled.h2`
    font-weight: 400;
`